module.exports = __webpack_public_path__ + "img/W-G34.e4881913.jpg";